<div class="dropdown-container">
  <div class="dropdown-wrapper" [ngClass]="'dropdown-' + variant">
    <!-- Main button -->
    <button
      class="dropdown-button"
      type="button"
      [class.disabled]="disabled"
      [class.open]="isOpen()"
      [disabled]="disabled"
      (click)="toggleDropdown()"
      [attr.aria-expanded]="isOpen()"
      [attr.aria-haspopup]="'listbox'"
      [attr.aria-controls]="isOpen() ? 'dropdown-menu-' + variant : null"
      role="combobox"
    >
      @if (withIcon && iconPosition === 'left') {
        <v-one-icon
          class="dropdown-icon icon-left"
          [class.rotated]="iconRotateOnOpen && isOpen()"
          [name]="customIconName"
          [type]="iconType"
          [color]="iconColor()"
        />
      }

      <span class="dropdown-label">
        {{ buttonLabel() | translate }}
      </span>

      @if (withIcon && iconPosition === 'right') {
        <v-one-icon
          class="dropdown-icon icon-right"
          [class.rotated]="iconRotateOnOpen && isOpen()"
          [name]="customIconName"
          [type]="iconType"
          [color]="iconColor()"
        />
      }

      @if (withDot && withIcon && iconPosition === 'right') {
        <div class="dropdown-icon icon-right-dot">
          <span>{{ notes().length }}</span>
        </div>
      }
    </button>

    @if (isOpen()) {
      <div
        class="dropdown-overlay"
        (click)="closeDropdown()"
        (keydown.escape)="closeDropdown()"
        tabindex="-1"
        role="presentation"
      ></div>
      <div
        @dropdownAnimation
        [id]="'dropdown-menu-' + variant"
        class="dropdown-menu"
        [class.with-checkbox]="multiple"
        (keydown)="onMenuKeydown($event)"
        tabindex="-1"
        role="listbox"
        [attr.aria-multiselectable]="multiple"
        (click)="$event.stopPropagation()"
      >
        <!-- Items without checkbox -->
        @if (!multiple) {
          @for (option of options; track option.value; let i = $index) {
            <button
              type="button"
              class="dropdown-item"
              [class.selected]="isOptionSelected(option)"
              [class.disabled]="option.disabled"
              [class.focused]="i === focusedIndex"
              [disabled]="option.disabled"
              [attr.aria-disabled]="option.disabled"
              role="option"
              [attr.aria-selected]="isOptionSelected(option)"
              (click)="selectOption(option)"
              (keydown.enter)="selectOption(option)"
            >
              <span class="item-label">{{ option.label | translate }}</span>
              @if (withDot && notes().length > 0) {
                @if (option.label.includes('Crédito')) {
                  @if (creditNotesCount() > 0) {
                    <span class="doten-label">{{ creditNotesCount() }}</span>
                  }
                } @else {
                  @if (debitNotesCount() > 0) {
                    <span class="doten-label">{{ debitNotesCount() }}</span>
                  }
                }
              }
            </button>
          }
        }

        <!-- Items with checkbox (multiple selection) -->
        @if (multiple) {
          @for (option of options; track option.value) {
            <div
              class="dropdown-item checkbox-item"
              [class.disabled]="option.disabled"
              (click)="!option.disabled && selectOption(option)"
              (keydown.enter)="!option.disabled && selectOption(option)"
              (keydown.space)="!option.disabled && selectOption(option)"
              [attr.tabindex]="option.disabled ? -1 : 0"
              role="checkbox"
              [attr.aria-checked]="isOptionSelected(option)"
              [attr.aria-disabled]="option.disabled"
            >
              <div class="custom-checkbox">
                <input
                  type="checkbox"
                  [id]="'checkbox-' + option.value"
                  [checked]="isOptionSelected(option)"
                  [disabled]="option.disabled"
                  (click)="$event.stopPropagation()"
                  tabindex="-1"
                />
                <span class="checkmark"></span>
              </div>

              <span class="item-label">{{ option.label | translate }}</span>
            </div>
          }
        }
      </div>
    }
  </div>
</div>
